
import React from 'react';
import { connect } from 'react-redux'
import CardForm from '../card-form'

import { formatKennitala } from '../../utils';
import { fetchSaveVirtualCard, removeVirtualCard } from '../../api/virtual-card/actions';
import { removeTempCC } from '../../api/payers/actions';

class AdminFunctions extends React.Component {

    constructor(props) {
        super(props)
    }

   

    render() {
        const payer =  (this.props.customers.lastLookup.Customer && this.props.customers.lastLookup.Customer.Name)
            ? this.props.customers.lastLookup.Customer
            : (this.props.customers.customerList && this.props.customers.customerList.length > 0 ? this.props.customers.customerList[0].Customer : null);

        console.log(payer)
        return (
            payer !== null
            ?
            <div className="container admin-functions xs-pt-10 xs-pb-50">
                <div className="row">
                    <div className="col-12 text-center button-container">
                        <h3>{payer.Name} ({ formatKennitala(payer.AccountNum)})</h3>
                        <p>Skipta um greiðslukort</p>
                        <CardForm className="card-form" shouldAutoSave={true} virtualCard={this.props.virtualCard} payerId={payer.AccountNum} dispatch={this.props.dispatch} payers={this.props.payers} />
                    </div>
                </div>
            </div> 
            : <></>
        )
    }
}

AdminFunctions.defaultProps = { }

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        currency: {},
        nationalRegistry: {},
        virtualCard: {},
        payers: {},
        insuranceTakers: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.currency = (state.currency === undefined) ? {} : state.currency
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.virtualCard = (state.virtualCard === undefined) ? {} : state.virtualCard
    f.payers = (state.payers === undefined) ? {} : state.payers
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers

    return f;
}

export default connect(mapStateToProps)(AdminFunctions);